import React, { useCallback, useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import styled from 'styled-components';

const EditButton = styled.button`
	border: none;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
`;

export const Table = ({ data, onRowSelected, defaultAlias, onEditAlias }) => {
	const gridRef = useRef();
	const gridStyle = useMemo(() => ({ height: '100%', width: '100%' }), []);
	const defaultColDef = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
		};
	}, []);

	const columnDefs = [
		{
			headerName: 'Alias Name',
			field: 'aliasName',
			headerCheckboxSelection: true,
			checkboxSelection: true,
			sortable: true,
		},
		{ field: 'industryValue', headerName: 'Industry', sortable: true },
		{ field: 'headCount', headerName: 'Head Count' },
		{ field: 'revenue', headerName: 'Revenue', sortable: true },
		{ field: 'headOfficeLocationValue', headerName: 'Headoffice Location' },
		{
			headerName: 'Action',
			cellRendererFramework: params => {
				return (
					<div>
						<EditButton
							onClick={() => {
								onEditAlias(params.data);
							}}
						>
							Edit
						</EditButton>
					</div>
				);
			},
		},
	];

	const onFirstDataRendered = useCallback(
		params => {
			gridRef.current.api.forEachNode(node => {
				if (node.data && defaultAlias.includes(node.data.aliasName)) {
					node.setSelected(true);
				}
			});
		},
		[defaultAlias]
	);

	return (
		<>
			{data.length > 0 ? (
				<div style={gridStyle} className="ag-theme-balham">
					<AgGridReact
						ref={gridRef}
						rowData={data}
						columnDefs={columnDefs}
						defaultColDef={defaultColDef}
						rowSelection={'multiple'}
						suppressRowClickSelection={true}
						pagination={true}
						paginationPageSize={100}
						onFirstDataRendered={onFirstDataRendered}
						onRowSelected={onRowSelected}
						domLayout={'autoHeight'}
					/>
				</div>
			) : (
				<p>Alias not available.</p>
			)}
		</>
	);
};

export const AliasListTable = React.memo(Table);
